module.exports = __webpack_public_path__ + "img/companyone.84490f14.png";